<template>
    <div
          class="modal addnew-cusip"
          id="addcusip"
          tabindex="-1"
          role="dialog"
          aria-labelledby="exampleModalLabel"
          aria-hidden="true"
        >
      <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">CANCEL OFFERING</h5>
              <button type="button" class="close" aria-label="Close"  @click="$emit('close')">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
                <div class="row">
                 <div class="col-md-12 col-lg-12">
                    <label for="filter" class="col-form-label">ECN's</label>
                    <multiselect 
                      v-model="selectedEcn" 
                      placeholder="Select" 
                      :options="ecnList" 
                      :multiple="true" 
                      :limit="4"  ></multiselect>
                  </div>
                  </div>
            </div>
            <div v-if="loading" class="loader"><img src="@/assets/img/loader.svg" alt=""/></div>
            <div class="modal-footer bid">
              <button type="button" class="btn btn-secondary" @click="$emit('close')">CLOSE</button>
              <button :disabled ="selectedEcn.length == 0"  type="button" class="btn btn-danger" @click="cancelOffer()">CANCEL</button>
            </div>
          </div>
        </div>
      </div>
</template>
<script>
//import config from "@/config";
import config from "@/config";
import authService from "@/authService";
export default {
  name: "canceloffer",
  props : ['offerData'],
  data() {
    return {
        loading : false,
        ecnList : ["IBP","TMC","TWD"],
        selectedEcn :  ["IBP","TMC","TWD"],
    };
  },
  methods: {
    cancelOffer(){
      ///offer/cancel-stuck;
      var data = []
      this.offerData.forEach(element => {
          var obj = {};
              obj.offerId = element;
              obj.ecns = this.selectedEcn.map((e) => {
                return { ecn : e ,cancel : true }
              });
              data.push(obj);
      });
      
      var message = "Are you sure you want to cancel selected offers?";
      this.$confirm(message,"","",{confirmButtonText:"Cancel",cancelButtonText : "No"}).then(() => {
          this.loading = true;
          const auth = {
              headers: { 'org-token' : authService.getOrgToken()  }
          };
          this.$http
          .put(config.baseUrlBidSide + "/offer/cancel-stuck",data,auth)
          .then(() => {
            this.loading = false;
            this.$emit('close')              
          })
          .catch(() => {
              this.loading = false;              
          });
      });
    }

  },
  mounted() {
      
      console.log(this.offerData)
   
  }
};
</script>